import React from 'react';
import { createPortal } from 'react-dom';
import { MegaMenuColumn } from '../MegaMenuColumn';
import classNames from 'classnames';
import { useMegaMenuState } from '../MegaMenuState';
import './MegaMenuItem.scss';
import { useMegaMenuItemHover } from './MegaMenuItem.hooks';
import { Section } from '@layouts/MegaMenu/MegaMenu.types';

interface MegaMenuItemProps {
  title: string;
  href: string;
  level: number;
  items: Section[];
  hasChildren: boolean;
  className?: string;
}

export const MegaMenuItem = ({
  title,
  href,
  level,
  items,
  hasChildren,
  className,
}: MegaMenuItemProps) => {
  const { activeItems, addActiveItem } = useMegaMenuState();
  const isActive = activeItems[level] === title;
  const isMobileDevice = navigator.maxTouchPoints > 0;

  const onHover = () => {
    addActiveItem(level, title);
  };

  const { isHovered, onMouseEnter, onMouseLeave } = useMegaMenuItemHover(onHover);

  const doHightlightLink = () => {
    if (isMobileDevice) {
      return href && hasChildren;
    }
    return isHovered && href && hasChildren;
  };

  const showChildren = isActive && hasChildren;

  const nextLevel = level + 1;
  return (
    <div className={classNames('l-megaMenu-column-item-wrapper', className)}>
      <span
        className={classNames('l-megaMenu-column-item', {
          'level-1': level === 1,
          'level-2': level === 2,
          'level-3': level === 3,
          'level-4': level === 4,
          active: isActive && hasChildren,
        })}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        onClick={() => {
          if (!isMobileDevice && href) {
            window.location.href = href;
          }
        }}
      >
        <a className={doHightlightLink() ? 'highlight-link' : ''} href={href || undefined}>
          {title}
        </a>
        {hasChildren && <i className='icon-angle-right' />}
      </span>
      {showChildren &&
        createPortal(
          <MegaMenuColumn items={items} level={nextLevel} />,
          document.querySelector(`.l-megaMenu-navigation-col.level-${nextLevel}`)
        )}
    </div>
  );
};
